import React from 'react';
import { useSelector } from 'react-redux';
import Icon from '../../../ui/icons/Icon';
import iconsList from '../../../ui/icons/iconsList';
import classes from '../FinalDateComp/FinalDateComp.module.css';

const FinalDateCompCharedi = () => {

  const { texts } = useSelector((state) => state.translate);
  const dateObjGirls = new Date(window.config?.finalDateGirls);
  const dateObjBoys = new Date(window.config?.finalDateBoys);
  const displayDateGirls = dateObjGirls?.toLocaleDateString("he-IL", { day: "2-digit", month: "2-digit" }) ?? '';
  const timeGirls = dateObjGirls?.toLocaleTimeString("he-IL", { hour: "2-digit", minute: "2-digit" }) ?? '';
  const timeBoys = dateObjBoys?.toLocaleTimeString("he-IL", { hour: "2-digit", minute: "2-digit" }) ?? '';

  return (
    <div className={classes.finalDate} >
      <div className={classes.row} >
        <div className={classes.dateBlock}>
          <div className={classes.labelBlock}>
            <span className={classes.label}>{texts.finalOnDayLabelCharedi}</span>
            <Icon name={iconsList.calendar} className={classes.icon} color="#070C43" />
          </div>
          <div className={classes.date}>
            <span className={classes.pill}> <p className={classes.pillText}>{displayDateGirls}</p></span>
            <span className={classes.pill}><p className={classes.pillText}>{texts.virtualFinalEventStepHebrewDateCharedi}</p></span>
          </div>
        </div>
        <div className={classes.dateBlock}>
          <div className={classes.labelBlock}>
            <span className={classes.label}>{texts.startsAtTimeLabelCharedi}</span>
            <Icon name={iconsList.clock} className={classes.icon} color="#070C43" />
          </div>
          <span className={classes.pillCharedi}>
            <p className={classes.pillTextTitle}>{texts.finalSection_girlsFinalLabel}</p>
            <p className={classes.pillText}>{timeGirls}</p>
          </span>
          <span className={classes.pillCharedi}>
            <p className={classes.pillTextTitle}>{texts.finalSection_boysFinalLabel}</p>
            <p className={classes.pillText}>{timeBoys}</p>
          </span>
        </div>
      </div>
    </div>
  );
};

export default FinalDateCompCharedi;
